import React from 'react';
import { Card } from 'react-bootstrap';

const ComplementoSectorFinancieroResumen = ({ data = [], onEdit, onListChange }) => {
  // const handleEdit = (item) => {
  //   onEdit(item);
  // }

  // const handleDelete = (item) => {
  //   const newData = data.filter((value) => item.id !== value.id);

  //   onListChange(newData);
  // }

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">Sector financiero, Versión {data.Version}</Card.Subtitle>
        <br />
        <strong className="text-info card-label-info">Id Fideicomiso: </strong>
        {data.IdFideicom}
        <br />

        <strong className="text-info card-label-info">Nombre Fideicomiso: </strong>
        {data.NomFideicom}
        <br />

        <strong className="text-info card-label-info">Descripción Fideicomiso: </strong>
        {data.DescripFideicom}
        <br />
      </Card.Body>
    </Card>
  );
};

export default ComplementoSectorFinancieroResumen;
